import { DependentRelationship } from "./enums/dependent-relationship";
import {isBefore, sub,format } from "date-fns";
import { EnrollmentType } from "./enums/enrollment-type";
import { PlanType } from "./enums/plan-type";

export const isDomesticPartnerAffidavitRequired = (relationshpId, unmodifiedContact, dependentId, selections) => {
    const isDomesticPartner = relationshpId === DependentRelationship.DomesticPartner;
    if(!isDomesticPartner)
        return false;
    var onlyInCompanyPaid = selections?.filter(s => s.planType !== PlanType.BasicLife && s.dependents?.find(d => d === dependentId)).length === 0;
    if(onlyInCompanyPaid)
        return false;

    if(isNaN(dependentId))
        return true;

    const wasNotPreviouslyDomesticPartner = unmodifiedContact?.relationship.id !== DependentRelationship.DomesticPartner
    
    return wasNotPreviouslyDomesticPartner;
}

export const isEoiRequired = (amount, unmodifiedAmount, planSelected, enrollmentType, guaranteeAmount) => {
    if(amount)
        amount = parseInt(amount);
    if(!amount || amount === 0)
        return false;
    if(unmodifiedAmount === amount)
        return false;
    if(!planSelected || unmodifiedAmount > amount)
        return false;
    if(enrollmentType === EnrollmentType.NewHire && amount <= guaranteeAmount)
        return false;
    return true;
}

export const isDomesticPartnerOnlyInCompanyPaid = (relationshpId, unmodifiedContact, dependentId, selections) => {
    const isDomesticPartner = relationshpId === DependentRelationship.DomesticPartner;
    if(!isDomesticPartner)
        return false;
    var onlyInCompanyPaid = selections.filter(s => s.planType !== PlanType.BasicLife && s.dependents?.find(d => d === dependentId)).length === 0;
    if(onlyInCompanyPaid)
        return false;
    return true;
}


export const isProofOfDisabilityRequired = (relationshipId, birthdate, unmodifiedContact, dependentId) => {
    const isChildRelationship = DependentRelationship.Children.includes(relationshipId);

    if(!birthdate || !isChildRelationship)
        return false;
        
    const olderThan27 = isBefore(new Date(birthdate),getMaxChildAge());
    const previouslySubmitted = isProofOfDisabilityAlreadySubmitted(dependentId, unmodifiedContact)

    return olderThan27 && isChildRelationship && !previouslySubmitted;
}

export const DependentIsChildAndOlderThan27 = (birthdate, relationship) => {
    const isChildRelationship = DependentRelationship.Children.includes(relationship);
    if(!isChildRelationship)
        return false;
    
    const olderThan27 = isBefore(new Date(birthdate),getMaxChildAge());

    return olderThan27;
}

export const FileExists = (enrollments, attachmentType) => {
   return enrollments?.attachments?.find(s => s.enrollmentAttachmentTypeId === attachmentType);
}

const isProofOfDisabilityAlreadySubmitted = (dependentId, unmodifiedContact) => {
    if(isNaN(dependentId) || !unmodifiedContact)
        return false;

    const olderThan27 = isBefore(new Date(unmodifiedContact.birthdate),getMaxChildAge());
    if(!olderThan27)
        return true;
    const isChildRelationship = DependentRelationship.Children.includes(unmodifiedContact.relationship.id);

    return olderThan27 && isChildRelationship;
}

const getMaxChildAge = () => {
    const yearsAgo = sub(new Date(),{years:26})
    const yearsAgoNum = format(yearsAgo, 'yyyy')
   
    return new Date(yearsAgoNum, 0 , 1);
}
